module.exports = __webpack_public_path__ + "00a257aa431e0308090e1ba4b8b0d689.svg";